import { animationTransition } from '@shared/utils/animationTransition';

import { styled, Box, Flex } from '@withjoy/joykit';
import type { CSSObject, StyleSystemProps } from '@withjoy/joykit/components/Box/Box.types';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledWidgetTriggerRoot = styled(Box)``;
export const StyledWidgetTriggerButton = styled(Box)``;

const widgetTriggerRootStyles: StyleSystemProps = {
  display: 'inline-flex',
  height: [8, null, 9],
  borderRadius: 'full',
  borderWidth: '1px',
  borderColor: 'mono3',
  borderStyle: 'solid',
  backgroundColor: 'white',
  boxShadow: '0px 4px 20px -10px rgba(0,0,0,0.2)',
  transition: animationTransition('background-color', 'color', 'border-color'),
  _hover: {
    backgroundColor: 'mono3',
  },
  _active: {
    backgroundColor: 'mono5',
  },
  _expanded: {
    backgroundColor: 'white',
    borderColor: 'black',
  },
};

const widgetTriggerMobileButtonStyles: CSSObject = {
  display: 'inline-flex',
  alignItems: 'center',
  typographyVariant: 'button1',
  svg: {
    marginRight: 0,
  },
};

const widgetTriggerButtonStyles: CSSObject = {
  display: 'inline-flex',
  alignItems: 'center',
  typographyVariant: 'button1',
  paddingY: 1,
  svg: {
    marginRight: 3,
  },
  _last: {
    paddingLeft: 0,
    paddingRight: 5,
  },
  _odd: {
    paddingX: 5,
  },
};

const widgetBannerStyles: StyleSystemProps = {
  backgroundColor: 'mono2',
  height: 10,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const cartCountContainerStyles: StyleSystemProps = {
  height: pxToRem(24),
  paddingX: 4,
  color: 'white',
  borderRadius: pxToRem(12),
};

export const styles = {
  widgetTriggerRoot: widgetTriggerRootStyles,
  widgetTriggerButton: widgetTriggerButtonStyles,
  widgetTriggerMobileButton: widgetTriggerMobileButtonStyles,
  widgetBanner: widgetBannerStyles,
  cartCountContainer: cartCountContainerStyles,
};

export const StyledMobileCartCircle = styled(Box)`
  position: absolute;
  top: 0.875rem;
  right: 1.5rem;
  width: 0.5rem;
  height: 0.5rem;
  background-color: #3506f2;
  border-radius: 50%;
`;

export const StyledTryChecklistWrapper = styled(Box)``;

export const StyledTryChecklistBackgroundImage = styled(Box)``;
const backgroundImageStyles: StyleSystemProps = {
  height: pxToRem(226),
  width: pxToRem(280),
  borderRadius: pxToRem(8),
  marginBottom: 6,
  backgroundColor: 'mono3',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
};

export const StyledTryChecklistButtonWrapper = styled(Flex)``;
const buttonWrapperStyles: StyleSystemProps = {};

export const StyledTryChecklistPrimaryButton = styled(Box)``;
const primaryButtonStyles: StyleSystemProps = {
  color: 'white',
  backgroundColor: 'black',
  borderRadius: pxToRem(20),
  marginRight: 5,
  paddingX: 5,
  paddingY: 4,
  _hover: {
    backgroundColor: 'mono13',
  },
  _active: {
    backgroundColor: 'mono14',
  },
};

export const tryChecklistStyles = {
  backgroundImage: backgroundImageStyles,
  buttonWrapper: buttonWrapperStyles,
  primaryButton: primaryButtonStyles,
};
